<script setup>
import { onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useAuthStore } from '@/mini/stores/auth'
import { useMessage } from '@/mini/composables/useMessage'
import Container from '@/mini/components/Container.vue'
import Boxes from '@/mini/components/Boxes.vue'
import Box from '@/mini/components/Box.vue'
import LoadingBox from '@/mini/components/LoadingBox.vue'

const router = useRouter()
const route = useRoute()
const authStore = useAuthStore()
const { showPersistentMessage, dismissMessage } = useMessage()

onMounted(async () => {
    const code = route.query.code
    const state = route.query.state
    const error = route.query.error
    const expectedState = sessionStorage.getItem('pkce_state')

    if (error || !code || state !== expectedState) {
        router.push({ name: 'login' })
        return
    }

    const msgId = showPersistentMessage('Signing in...', 'info')
    const redirectUri = `${window.location.origin}/callback`
    const ok = await authStore.handleCallback(code, redirectUri)
    dismissMessage(msgId)

    window.location.replace(ok ? '/' : '/login')
})
</script>

<template>
    <Container>
        <Boxes spaceTopBot fh class="align-content-start">
            <Box size="100">
                <LoadingBox />
            </Box>
        </Boxes>
    </Container>
</template>
